import { MemberFeatures, OrganizationFeatures } from '@trello/product-features';

export function hasGold(products: number[]) {
  return MemberFeatures.isFeatureEnabled('crown', products[0]);
}

export function hasPaidOrgPowerUps(organizations?: { products: number[] }[]) {
  return organizations?.some(({ products }) =>
    products.some((code) =>
      OrganizationFeatures.isFeatureEnabled('plugins', code),
    ),
  );
}
